<header-row
   [userName]="'Victoria Brown'"
   [userRole]="'REGIONAL MANAGER'"></header-row>

<div
   *ngIf="!isLoading"
   class="page-layout">
   <h2 class="main-title">Schedule Management</h2>
   <div class="stats-grid">
      <div
         class="stat-card"
         *ngFor="let stat of meetingStats">
         <div
            class="icon-circle"
            [ngClass]="stat.colorClass">
            <span class="material-icons">{{ stat.icon }}</span>
         </div>
         <div class="stat-info">
            <div class="count">{{ stat.count }}</div>
            <div class="label">{{ stat.label }}</div>
         </div>
      </div>
   </div>
   <div class="content-box">
      <div class="box-header">
         <h3>Meetings Overview</h3>
         <div class="filters">
            <div class="select-wrap">
               <p-multiSelect
                  [options]="hospitalList"
                  [(ngModel)]="selectedHospitals"
                  optionLabel="displayName"
                  placeholder="Filter by Hospital"
                  (onChange)="applyFilters()"
                  [showClear]="true"
                  [filter]="true"
                  [maxSelectedLabels]="1"
                  selectedItemsLabel="{0} hospitals selected"
                  appendTo="body"></p-multiSelect>
            </div>

            <div class="select-wrap">
               <p-multiSelect
                  [options]="uniqueAttendees"
                  [(ngModel)]="selectedAttendees"
                  placeholder="Filter by Attendees"
                  (onChange)="applyFilters()"
                  [showClear]="true"
                  [filter]="true"
                  [maxSelectedLabels]="1"
                  selectedItemsLabel="{0} attendees selected"
                  appendTo="body"></p-multiSelect>
            </div>

            <div>
               <button
                  class="reset-btn"
                  (click)="resetFilters()">
                  <span class="material-icons">refresh</span>
                  Reset Filters
               </button>
            </div>

            <button
               class="submit-btn"
               (click)="openNewMeetingDialog()">
               <span class="material-icons">add</span>
               New Meeting
            </button>
         </div>
      </div>

      <mat-tab-group
         class="scheduling-tabs"
         [selectedIndex]="selectedTabIndex"
         (selectedIndexChange)="onTabChange($event)">
         <!-- Upcoming Tab -->
         <mat-tab>
            <ng-template mat-tab-label>
               <span class="tab-label">Upcoming</span>
            </ng-template>

            <table
               mat-table
               [dataSource]="dataSource"
               class="mat-elevation-z1 data-table"
               matSort
               #upcomingSort="matSort">
               <!-- Subject Column -->
               <ng-container matColumnDef="subject">
                  <th
                     mat-header-cell
                     *matHeaderCellDef
                     mat-sort-header
                     style="width: 20%">
                     Subject
                  </th>
                  <td
                     mat-cell
                     *matCellDef="let row"
                     class="task-desc"
                     (click)="openMeetingDetailDialog(row)">
                     <span *ngIf="row.isRecurring" class="material-icons recurrence-icon" title="Recurring {{ row.recurrencePattern }}" style="font-size: 14px; vertical-align: middle; margin-right: 4px; color: #2e7d32;">repeat</span>
                     {{ row.meetingSubject | titlecase }}
                  </td>
               </ng-container>

               <!-- Hospital Column -->
               <ng-container matColumnDef="hospital">
                  <th
                     mat-header-cell
                     *matHeaderCellDef
                     mat-sort-header
                     style="width: 18%">
                     Hospital
                  </th>
                  <td
                     mat-cell
                     *matCellDef="let row"
                     class="hospital-col">
                     {{ row.hospitalName }}
                  </td>
               </ng-container>

               <!-- Scheduled Date Column -->
               <ng-container matColumnDef="date">
                  <th
                     mat-header-cell
                     *matHeaderCellDef
                     mat-sort-header
                     style="width: 15%">
                     Scheduled Date
                  </th>
                  <td
                     mat-cell
                     *matCellDef="let row"
                     class="date-col">
                     {{ row.scheduledDate | date: "MM/dd/yyyy" }}
                  </td>
               </ng-container>

               <!-- Duration Column -->
               <ng-container matColumnDef="duration">
                  <th
                     mat-header-cell
                     *matHeaderCellDef
                     mat-sort-header
                     style="width: 12%">
                     Duration
                  </th>
                  <td
                     mat-cell
                     *matCellDef="let row">
                     <span class="duration-badge">{{ row.duration }}</span>
                  </td>
               </ng-container>

               <!-- Time Zone Column -->
               <!-- <ng-container matColumnDef="timezone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:15%">Time Zone</th>
            <td mat-cell *matCellDef="let row">{{ row.timeZone }}</td>
         </ng-container> -->

               <!-- Attendees Column -->
               <ng-container matColumnDef="attendees">
                  <th
                     mat-header-cell
                     *matHeaderCellDef
                     style="width: 15%">
                     Attendees
                  </th>
                  <td
                     mat-cell
                     *matCellDef="let row"
                     class="attendees-col">
                     {{ row.attendeesNames }}
                  </td>
               </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                   <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="width: 5%"></th>
                   <td
                      mat-cell
                      *matCellDef="let row"
                      class="action-col">
                      <button
                         class="new-meeting-btn"
                         (click)="joinMeeting(row?.joinUrl)">
                         <span class="material-icons">videocam</span>
                         Go to meeting
                      </button>
                       <button
                          class="new-meeting-btn edit-btn"
                          (click)="openEditMeetingDialog(row, $event)"
                          title="Edit meeting">
                          <span class="material-icons">edit</span>
                       </button>
                       <button
                          class="new-meeting-btn delete-btn"
                          (click)="deleteMeeting(row, $event)"
                          title="Cancel meeting">
                          <span class="material-icons">delete_outline</span>
                       </button>
                    </td>
                 </ng-container>
                 <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumns"></tr>
                 <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    [attr.id]="'search-row-meeting-' + row.meetingId"></tr>
              </table>

              <div
                *ngIf="meetingList?.length === 0"
                style="padding: 20px; text-align: center; color: #999">
                <p>No upcoming meetings to display</p>
             </div>
          </mat-tab>

         <!-- History Tab -->
         <mat-tab>
            <ng-template mat-tab-label>
               <span class="tab-label">History</span>
            </ng-template>

            <table
               mat-table
               [dataSource]="dataSource"
               class="mat-elevation-z1 data-table"
               matSort
               #historySort="matSort">
               <!-- Subject Column -->
               <ng-container matColumnDef="subject">
                  <th
                     mat-header-cell
                     *matHeaderCellDef
                     mat-sort-header
                     style="width: 20%">
                     Subject
                  </th>
                  <td
                     mat-cell
                     *matCellDef="let row"
                     class="task-desc"
                     (click)="openMeetingDetailDialog(row)">
                     <span *ngIf="row.isRecurring" class="material-icons recurrence-icon" title="Recurring {{ row.recurrencePattern }}" style="font-size: 14px; vertical-align: middle; margin-right: 4px; color: #2e7d32;">repeat</span>
                     {{ row.meetingSubject | titlecase }}
                  </td>
               </ng-container>

               <!-- Hospital Column -->
               <ng-container matColumnDef="hospital">
                  <th
                     mat-header-cell
                     *matHeaderCellDef
                     mat-sort-header
                     style="width: 18%">
                     Hospital
                  </th>
                  <td
                     mat-cell
                     *matCellDef="let row"
                     class="hospital-col">
                     {{ row.hospitalName }}
                  </td>
               </ng-container>

               <!-- Scheduled Date Column -->
               <ng-container matColumnDef="date">
                  <th
                     mat-header-cell
                     *matHeaderCellDef
                     mat-sort-header
                     style="width: 15%">
                     Scheduled Date
                  </th>
                  <td
                     mat-cell
                     *matCellDef="let row"
                     class="date-col">
                     {{ row.scheduledDate | date: "MM/dd/yyyy" }}
                  </td>
               </ng-container>

               <!-- Duration Column -->
               <ng-container matColumnDef="duration">
                  <th
                     mat-header-cell
                     *matHeaderCellDef
                     mat-sort-header
                     style="width: 12%">
                     Duration
                  </th>
                  <td
                     mat-cell
                     *matCellDef="let row">
                     <span class="duration-badge">{{ row.duration }}</span>
                  </td>
               </ng-container>

               <!-- Time Zone Column -->
               <!-- <ng-container matColumnDef="timezone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:15%">Time Zone</th>
            <td mat-cell *matCellDef="let row">{{ row.timeZone }}</td>
         </ng-container> -->

               <!-- Attendees Column -->
               <ng-container matColumnDef="attendees">
                  <th
                     mat-header-cell
                     *matHeaderCellDef
                     style="width: 15%">
                     Attendees
                  </th>
                  <td
                     mat-cell
                     *matCellDef="let row"
                     class="attendees-col">
                     {{ row.attendeesNames }}
                  </td>
               </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                   <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="width: 5%"></th>
                   <td
                      mat-cell
                      *matCellDef="let row"
                      class="action-col">
                      <button
                         class="new-meeting-btn"
                         (click)="joinMeeting(row?.joinUrl)">
                         <span class="material-icons">videocam</span>
                         Go to meeting
                      </button>
                       <p-selectButton
                          class="new-meeting-btn edit-btn"
                          (click)="openEditMeetingDialog(row, $event)"
                          title="Edit meeting">
                          <span class="material-icons">edit</span>
                       </p-selectButton>
                       <button
                          class="new-meeting-btn delete-btn"
                          (click)="deleteMeeting(row, $event)"
                          title="Cancel meeting">
                          <span class="material-icons">delete_outline</span>
                       </button>
                    </td>
                 </ng-container>
                 <tr
                    mat-header-row
                   *matHeaderRowDef="displayedColumns"></tr>
                <tr
                   mat-row
                   *matRowDef="let row; columns: displayedColumns"
                   [attr.id]="'search-row-meeting-' + row.meetingId"></tr>
             </table>

             <!-- paginator removed from here, will be shared below -->

            <div
               *ngIf="dataSource?.data?.length === 0"
               style="padding: 20px; text-align: center; color: #999">
               <p>No historical meetings to display</p>
            </div>
         </mat-tab>
      </mat-tab-group>
      <mat-paginator
         [pageSize]="50"
         [pageSizeOptions]="[10, 20, 50, 100, 1000]"
         showFirstLastButtons
         aria-label="Select page of meetings"></mat-paginator>
   </div>
</div>

<div
   *ngIf="isLoading"
   style="
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.95);
      z-index: 9999;
   ">
   <div style="text-align: center">
      <img
         src="/assets/catSpinner.gif"
         style="width: 130px; margin-bottom: 20px" />
      <div style="color: #363636; font-size: 24px">Please wait...</div>
   </div>
</div>
